/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import { SubNavigationBarActionsHexFragmentDoc } from "./SubNavigationBarActions.generated";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type SetProjectOwnerMutationVariables = Types.Exact<{
  hexId: Types.Scalars["HexId"]["input"];
  nextOwnerUserId: Types.Scalars["UserId"]["input"];
}>;

export type SetProjectOwnerMutation = {
  readonly __typename: "Mutation";
  readonly setProjectOwner: {
    readonly __typename: "Hex";
    readonly id: c.HexId;
    readonly isShared: boolean;
    readonly publicRoleV2: Types.ProjectRole | null;
    readonly organizationRoleV2: Types.ProjectRole | null;
    readonly grantSummary: c.ProjectGrantSummary;
    readonly onlyGrantedToCurrentUser: boolean;
    readonly owner: {
      readonly __typename: "User";
      readonly id: c.UserId;
      readonly name: string | null;
      readonly email: string;
    };
    readonly lastPublishedVersion: {
      readonly __typename: "HexVersion";
      readonly id: c.HexVersionId;
    } | null;
    readonly org: {
      readonly __typename: "Org";
      readonly id: c.OrgId;
      readonly displayName: string;
      readonly allowPublicSharing: boolean;
      readonly resolvedAllowPublicSharing: boolean;
    };
  };
};

export const SetProjectOwnerDocument = /*#__PURE__*/ gql`
  mutation SetProjectOwner($hexId: HexId!, $nextOwnerUserId: UserId!) {
    setProjectOwner(hexId: $hexId, nextOwnerUserId: $nextOwnerUserId) {
      id
      ...SubNavigationBarActionsHexFragment
    }
  }
  ${SubNavigationBarActionsHexFragmentDoc}
`;
export type SetProjectOwnerMutationFn = Apollo.MutationFunction<
  SetProjectOwnerMutation,
  SetProjectOwnerMutationVariables
>;

/**
 * __useSetProjectOwnerMutation__
 *
 * To run a mutation, you first call `useSetProjectOwnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetProjectOwnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setProjectOwnerMutation, { data, loading, error }] = useSetProjectOwnerMutation({
 *   variables: {
 *      hexId: // value for 'hexId'
 *      nextOwnerUserId: // value for 'nextOwnerUserId'
 *   },
 * });
 */
export function useSetProjectOwnerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetProjectOwnerMutation,
    SetProjectOwnerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetProjectOwnerMutation,
    SetProjectOwnerMutationVariables
  >(SetProjectOwnerDocument, options);
}
export type SetProjectOwnerMutationHookResult = ReturnType<
  typeof useSetProjectOwnerMutation
>;
export type SetProjectOwnerMutationResult =
  Apollo.MutationResult<SetProjectOwnerMutation>;
export type SetProjectOwnerMutationOptions = Apollo.BaseMutationOptions<
  SetProjectOwnerMutation,
  SetProjectOwnerMutationVariables
>;
